
import React from 'react';
import { useTranslationUtils } from '@/hooks/useTranslationUtils';
import { ImageUploader } from '../upload';

interface ImageUploadSectionProps {
  title: string;
  description: string;
  existingUrl: string | null;
  onUpload: (url: string) => void;
  disabled?: boolean;
  previewLabel?: string;
}

const ImageUploadSection: React.FC<ImageUploadSectionProps> = ({
  title,
  description,
  existingUrl,
  onUpload,
  disabled = false,
  previewLabel
}) => {
  const { t } = useTranslationUtils();

  return (
    <div className="space-y-3">
      <div className="flex flex-col space-y-1">
        <h3 className="text-sm font-medium">{title}</h3>
        <p className="text-xs text-muted-foreground">
          {description}
        </p>
      </div>
      <ImageUploader
        existingUrl={existingUrl}
        onUpload={onUpload}
        accept="image/*"
        bucketName="app_assets"
        showPreview={true}
        disabled={disabled}
      />
      {previewLabel && existingUrl && (
        <p className="text-xs text-muted-foreground mt-1">{previewLabel}</p>
      )}
    </div>
  );
};

export default ImageUploadSection;
